function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_x0020_1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M837.84 234.22l-512.03 256.57c-47.56,-24.91 -90.5,-69.05 -178.38,-43.47 -56.73,16.51 -104.45,64.84 -107.49,143.87 -2.88,74.75 43.19,127.91 90.19,150.86 86.24,42.11 140.12,-3.86 193.89,-35.17l511.43 255.26c5.53,216.75 179.36,215.72 257.99,161.67 106.47,-73.21 68.37,-270.99 -81.57,-284.85 -108.72,-10.05 -109.95,62.5 -165.69,38.82 -51.46,-21.86 -114.58,-58.2 -165.22,-83.65 -89.01,-44.72 -239.49,-130.68 -325.63,-158.89l1.71 -65.52c28.6,-27.66 455.23,-240.5 515.78,-261.62 65.88,42.44 119.86,80.65 213.26,22.93 54.76,-33.85 92.72,-123.95 49.45,-206.94 -71.37,-136.91 -313.7,-111.07 -297.69,110.13z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  width: 1194.09,
  height: 1194.09
}));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlSpace: "preserve",
    width: "2em",
    height: "2em",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1194.1 1194.09",
    role: "img",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.ac93816f.svg";
export { ForwardRef as ReactComponent };